import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import GfyVideo from './GfyVideo';
import GfyEmbed from './GfyEmbed';
import './styles.scss';

const propTypes = {
  limit: PropTypes.number,
  gfyData: PropTypes.array,
};

const defaultProps = {
  limit: 2,
  gfyData: [
    {embed_url: 'https://giphy.com/embed/l0Iy9uqEumuJv12Ok'},
    {embed_url: 'https://giphy.com/embed/l0IygV3FVD52vreKc'},
    {embed_url: 'https://giphy.com/embed/3oKIP6i4qNmF88rgfS'},
    {embed_url: 'https://giphy.com/embed/xUA7aQmyqw0dKn80SY'},
    {embed_url: 'https://giphy.com/embed/xUPGcfg3WLv1hcK304'}
  ]
};

class GfyView extends React.Component {

  render() {
    const {limit, gfyData} = this.props;

    return (
        <div className="row">
        <div className="col-12">
          <div className="row sm-gutters">
            {
              gfyData.map( (gfy, index) => {
                if (index < limit) {
                  return (
                    <div className="col-12 col-md-6" key={index}>
                      <GfyEmbed gfy={gfy} />
                    </div>
                  );
                }
              })
            }
          </div>
        </div>
        <div className="col-12 pt-15">
        <div className="row d-flex justify-content-center">
          <div className="">
            <Link to="/subscribe" className="d-flex justify-content-center align-items-center daily-dose-btn text-btn text-center text-uppercase m-auto">Visit Daily Dose of Love Page</Link>
          </div>
        </div>
        </div>
        </div>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    gfyData: state.gfy.data
  };
}

GfyView.propTypes = propTypes;
GfyView.defaultProps = defaultProps;

export default connect(mapStateToProps)(GfyView);
